import React from "react";

const SmartWatchMDM = () => {
  return (
    <>
      <style>
        {`
          @keyframes gradientMove {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translateY(0px) translateX(0px);
            }
            33% {
              transform: translateY(-30px) translateX(15px);
            }
            66% {
              transform: translateY(15px) translateX(-15px);
            }
          }

          @keyframes rotateWatch {
            0% {
              transform: rotateY(0deg) rotateZ(-5deg);
            }
            50% {
              transform: rotateY(180deg) rotateZ(5deg);
            }
            100% {
              transform: rotateY(360deg) rotateZ(-5deg);
            }
          }

          @keyframes pulse {
            0%, 100% {
              opacity: 0.6;
              transform: scale(1);
            }
            50% {
              opacity: 1;
              transform: scale(1.05);
            }
          }

          .project-page {
            position: relative;
            background: linear-gradient(-45deg, #000000, #0a0a0a, #1a0a1a, #0a1a2a);
            background-size: 400% 400%;
            animation: gradientMove 15s ease infinite;
            min-height: 100vh;
            padding: 90px 20px;
            color: #fff;
            font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
            overflow: hidden;
          }

          .project-page::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: 
              radial-gradient(circle at 20% 30%, rgba(96, 165, 250, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 70%, rgba(236, 72, 153, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 40% 80%, rgba(167, 139, 250, 0.08) 0%, transparent 50%);
            animation: float 20s ease-in-out infinite;
            pointer-events: none;
          }

          .project-page::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: 
              repeating-linear-gradient(
                0deg,
                transparent,
                transparent 2px,
                rgba(255, 255, 255, 0.03) 2px,
                rgba(255, 255, 255, 0.03) 4px
              ),
              repeating-linear-gradient(
                90deg,
                transparent,
                transparent 2px,
                rgba(255, 255, 255, 0.03) 2px,
                rgba(255, 255, 255, 0.03) 4px
              );
            pointer-events: none;
          }

          .project-container {
            max-width: 1200px;
            margin: auto;
            position: relative;
            z-index: 1;
          }

          .project-badge {
            display: inline-block;
            background: linear-gradient(135deg, #60a5fa, #ec4899);
            padding: 8px 24px;
            border-radius: 30px;
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 30px;
            text-transform: uppercase;
            letter-spacing: 1.5px;
          }

          .project-title {
            font-size: 52px;
            font-weight: 700;
            margin-bottom: 40px;
            letter-spacing: 1px;
            background: linear-gradient(135deg, #60a5fa, #ec4899, #a78bfa, #60a5fa);
            background-size: 300% 300%;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            animation: gradientMove 8s ease infinite;
          }

          .hero-section {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 60px;
            align-items: center;
            margin-bottom: 100px;
          }

          .hero-content {
            padding-right: 20px;
          }

          .hero-text {
            font-size: 18px;
            line-height: 1.9;
            color: #d1d5db;
            text-align: justify;
            margin-bottom: 20px;
          }

          .watch-animation-container {
            position: relative;
            height: 500px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .watch-visual {
            position: relative;
            width: 280px;
            height: 280px;
            animation: rotateWatch 20s linear infinite;
          }

          .watch-circle {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background: linear-gradient(145deg, #1a1a1a, #2a2a2a);
            border: 8px solid;
            border-color: #60a5fa #ec4899 #a78bfa #60a5fa;
            box-shadow: 
              0 0 60px rgba(96, 165, 250, 0.4),
              0 0 100px rgba(236, 72, 153, 0.3),
              inset 0 0 40px rgba(0, 0, 0, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            animation: pulse 3s ease-in-out infinite;
          }

          .watch-screen {
            width: 200px;
            height: 200px;
            border-radius: 50%;
            background: linear-gradient(135deg, #0a0a0a, #1a1a1a);
            border: 3px solid rgba(96, 165, 250, 0.3);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 10px;
          }

          .watch-icon {
            font-size: 60px;
          }

          .watch-text {
            font-size: 14px;
            color: #60a5fa;
            font-weight: 600;
            letter-spacing: 2px;
          }

          .glow-ring {
            position: absolute;
            width: 350px;
            height: 350px;
            border-radius: 50%;
            border: 2px solid rgba(96, 165, 250, 0.2);
            animation: pulse 4s ease-in-out infinite;
          }

          .glow-ring:nth-child(2) {
            width: 400px;
            height: 400px;
            border-color: rgba(236, 72, 153, 0.15);
            animation-delay: 1s;
          }

          .description-section {
            background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
            padding: 60px;
            border-radius: 20px;
            margin-bottom: 40px;
            box-shadow: 0 25px 50px rgba(0, 0, 0, 0.7);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .description-section:hover {
            transform: translateY(-8px);
            box-shadow: 0 30px 60px rgba(0, 0, 0, 0.9);
          }

          .section-title {
            font-size: 32px;
            font-weight: 600;
            margin-bottom: 25px;
            background: linear-gradient(135deg, #60a5fa, #ec4899);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .section-text {
            font-size: 17px;
            line-height: 1.9;
            color: #d1d5db;
            text-align: justify;
            margin-bottom: 20px;
          }

          @media (max-width: 968px) {
            .hero-section {
              grid-template-columns: 1fr;
              gap: 40px;
            }

            .project-title {
              font-size: 38px;
            }

            .watch-animation-container {
              height: 400px;
            }

            .description-section {
              padding: 40px;
            }
          }
        `}
      </style>

      <section className="project-page">
        <div className="project-container">
          <div className="project-badge">Upcoming Project</div>
          <h1 className="project-title">Smart Watch MDM</h1>

          {/* Hero Section */}
          <div className="hero-section">
            <div className="hero-content">
              <p className="hero-text">
                Zyntro Software Solutions is proud to introduce our upcoming revolutionary project: Smart Watch MDM (Mobile Device Management). This innovative solution combines the power of advanced wearable technology with enterprise-grade device management capabilities, designed specifically for modern businesses seeking seamless control and monitoring of their smart watch fleet.
              </p>
              <p className="hero-text">
                Our Smart Watch MDM solution empowers organizations to deploy, manage, and secure smart watches across their workforce with unprecedented ease and efficiency. From healthcare providers to logistics companies, retail chains to educational institutions, our platform ensures complete visibility and control over every device in your ecosystem.
              </p>
            </div>

            <div className="watch-animation-container">
              <div className="glow-ring"></div>
              <div className="glow-ring"></div>
              <div className="watch-visual">
                <div className="watch-circle">
                  <div className="watch-screen">
                    <div className="watch-icon">⌚</div>
                    <div className="watch-text">MDM</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Description Section 1 */}
          <div className="description-section">
            <h2 className="section-title">Comprehensive Device Management</h2>
            <p className="section-text">
              At the core of our Smart Watch MDM solution lies a sophisticated management platform that provides organizations with complete control over their smart watch infrastructure. Our system enables IT administrators to remotely configure device settings, deploy applications, enforce security policies, and monitor device health in real-time. The intuitive dashboard provides a centralized view of all managed devices, allowing for efficient oversight of hundreds or even thousands of smart watches simultaneously.
            </p>
            <p className="section-text">
              The platform supports automated enrollment processes, making it effortless to onboard new devices into your organization's ecosystem. With role-based access controls, you can define granular permissions for different user groups, ensuring that employees have access to the features and applications they need while maintaining strict security protocols. Our solution also includes comprehensive reporting and analytics capabilities, providing valuable insights into device usage patterns, application performance, and potential security threats.
            </p>
            <p className="section-text">
              Beyond basic management, our Smart Watch MDM solution offers advanced features such as geofencing, which allows organizations to define virtual boundaries and receive alerts when devices enter or exit specific areas. This is particularly valuable for industries requiring strict location-based security compliance. Additionally, the platform supports over-the-air updates, ensuring that all devices remain up-to-date with the latest firmware and security patches without requiring manual intervention.
            </p>
          </div>

          {/* Description Section 2 */}
          <div className="description-section">
            <h2 className="section-title">Enterprise-Grade Security & Scalability</h2>
            <p className="section-text">
              Security is paramount in today's digital landscape, and our Smart Watch MDM solution has been built from the ground up with enterprise-grade security measures. The platform implements multi-layered encryption for all data transmission between devices and the management server, ensuring that sensitive information remains protected at all times. In the event of a device being lost or stolen, administrators can remotely lock or wipe the device, preventing unauthorized access to corporate data and applications.
            </p>
            <p className="section-text">
              Our solution integrates seamlessly with existing enterprise security infrastructure, including single sign-on (SSO) systems, multi-factor authentication (MFA), and identity management platforms. This ensures that your smart watch deployment aligns with your organization's broader security framework. The platform also includes advanced threat detection capabilities, monitoring for suspicious activities and potential security breaches, and providing immediate alerts to administrators when anomalies are detected.
            </p>
            <p className="section-text">
              Designed with scalability in mind, our Smart Watch MDM platform can accommodate organizations of any size, from small businesses managing a handful of devices to large enterprises with global deployments. The cloud-based architecture ensures high availability and reliability, with automatic scaling to handle increased demand. Whether you're starting with a pilot program or rolling out thousands of devices across multiple locations, our solution grows with your needs. Backed by Zyntro's commitment to innovation and excellence, Smart Watch MDM represents the future of wearable device management in the enterprise.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default SmartWatchMDM;